import { render, staticRenderFns } from "./balloons.vue?vue&type=template&id=455df677&scoped=true&"
import script from "./balloons.vue?vue&type=script&lang=ts&"
export * from "./balloons.vue?vue&type=script&lang=ts&"
import style0 from "./balloons.vue?vue&type=style&index=0&id=455df677&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455df677",
  null
  
)

export default component.exports